import React from 'react'

function Contest() {
  return (
    <div style={{marginTop:'57px'}}>Contest</div>
  )
}

export default Contest